/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M21.518 70.657l3.373-1.48.871 12.108h13.8V66.563c0-9.276-7.456-16.793-16.644-16.793-9.2 0-16.656 7.529-16.656 16.793v14.722h15.692l-.436-10.628zm6.722-23.594c7.96 0 14.407-6.51 14.407-14.537C42.647 24.5 36.189 18 28.239 18c-7.96 0-14.419 6.5-14.419 14.526s6.459 14.537 14.42 14.537zm29.067 5.1c-8.65 2.788-10.656 9.183-10.656 16.516v12.617h8.42l.505-10.987h3.177v10.987h22.14V70.31H84l.516 10.987h8.408v-12.63c0-5.794-5.897-13.23-10.956-16.504-3.062 3.216-7.272 5.737-12.044 5.737-5.862.011-9.601-1.157-12.618-5.736z"
    ></path>
    <path
      fill="#B92A2E"
      d="M69.273 56.593c7.56 0 13.685-6.176 13.685-13.797 0-7.622-6.126-13.798-13.685-13.798-7.56 0-13.685 6.176-13.685 13.798 0 7.621 6.125 13.797 13.685 13.797zM45.264 46.102l1.168 1.968c5.555-3.343 7.374-10.594 4.057-16.192l-1.953 1.177a9.575 9.575 0 011.052 7.206 9.509 9.509 0 01-4.324 5.84z"
    ></path>
    <path
      fill="#B92A2E"
      d="M47.344 39.298c.47-1.8.138-3.627-.774-5.107l-1.98 1.141c.616.99.837 2.21.515 3.423a4.476 4.476 0 01-2.137 2.772l1.179 1.916c1.548-.891 2.727-2.344 3.197-4.145z"
    ></path>
  </Svg>
)

export default Icon
